import React, { Component } from "react";
import { Button, FormControl, FormGroup, Modal, ModalDialog, Tab, Tabs } from "react-bootstrap";
import { customCloneFiles } from "./ImageManager";
import { getLocaleCountryMap } from "../../Common/utils";
import { defineMessages, FormattedMessage } from "react-intl";
import globalMessages from "../../intl/globalMessages";
import styled from "styled-components";

const messages = defineMessages({
  ...globalMessages,
  editImage: {
    id: "app.imageManager.editImage",
    description: "Edit Image",
    defaultMessage: "Edit Image",
  },
  name: {
    id: "app.imageManager.name",
    description: "Name",
    defaultMessage: "Name",
  },
  title: {
    id: "app.imageManager.title",
    description: "Title",
    defaultMessage: "Title",
  },
  description: {
    id: "app.imageManager.description",
    description: "Description",
    defaultMessage: "Description",
  },
  cancel: {
    id: "app.imageManager.cancel",
    description: "Cancel",
    defaultMessage: "Cancel",
  },
  saveChanges: {
    id: "app.imageManager.saveChanges",
    description: "Save Changes",
    defaultMessage: "Save Changes",
  },
  noSpecials: {
    id: "app.imageManager.noSpecials",
    description: "Blank spaces and special characters, except underscore ( _ ), are not allowed",
    defaultMessage: "Blank spaces and special characters, except underscore ( _ ), are not allowed",
  },
});

const StyledTabs = styled(Tabs)`
  padding: 15px;
`;

class ImageManagerModalEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tempFiles: this.props.initialFiles,
      modalAlreadyExists: false,
      modalContainsSpecial: false,
    };
    this.localeCountryMap = getLocaleCountryMap({
      locales: this.props.locales,
    });
  }

  changeImageTranslations = (caller, locale, event, type, files) => {
    const lFiles = customCloneFiles(files);
    const index = [lFiles.findIndex(file => file.id === caller)];
    lFiles[index].translations[locale] = lFiles[index].translations[locale] || {};
    lFiles[index].translations[locale][type] = event.target.value;
    this.setState({ tempFiles: lFiles });
  };

  render() {
    const { caller, locales, showModalEdit, onModalChange, handleClose } = this.props;
    const { tempFiles, modalAlreadyExists, modalContainsSpecial } = this.state;

    const index = tempFiles.findIndex(file => file.id === caller);

    const input = (caller, type, index, locale, label, tempFiles) => (
      <FormGroup>
        <label> {label} </label>
        <FormControl
          type="text"
          onChange={event => this.changeImageTranslations(caller, locale, event, type, tempFiles)}
          value={
            tempFiles[index] &&
            tempFiles[index].translations &&
            tempFiles[index].translations[locale] &&
            tempFiles[index].translations[locale][type]
          }
          className="form-control"
        />
      </FormGroup>
    );

    const Dialog = props => (
      <div className="witadmin-bs3">
        <ModalDialog {...props} />
      </div>
    );

    return (
      <Modal
        show={!!showModalEdit}
        onHide={handleClose}
        dialogComponentClass={Dialog}
        bsSize="large"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.editImage} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StyledTabs defaultActiveKey={locales && locales[0]}>
            {locales &&
              locales.map(locale => (
                <Tab
                  key={locale}
                  eventKey={locale}
                  title={
                    <span className={`flag-icon flag-icon-${this.localeCountryMap[locale]}`} />
                  }>
                  {input(
                    caller,
                    "title",
                    index,
                    locale,
                    <FormattedMessage {...messages.title} />,
                    tempFiles
                  )}
                  {input(
                    caller,
                    "description",
                    index,
                    locale,
                    <FormattedMessage {...messages.description} />,
                    tempFiles
                  )}
                </Tab>
              ))}
          </StyledTabs>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose}>
            {" "}
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button
            onClick={() =>
              !modalAlreadyExists && !modalContainsSpecial && onModalChange(tempFiles)
            }>
            <FormattedMessage {...messages.saveChanges} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ImageManagerModalEdit;
